import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';

const StyledStoreIconButton = styled(Link)`
  width: 7.875rem;
  height: 3rem;
  padding: 0;
  display: inline-block;

  & + & {
    margin-left: .5rem;
  }

  & svg {
    height: 100%;
    width: 100%;
  }
`;

StyledStoreIconButton.displayName = 'StyledStoreIconButton';

export default StyledStoreIconButton;
